const initialState = {
  isrLeaseRanges: [
    {
      lowerLimit: 0.01,
      upperLimit: 496.07,
      fixedFee: 0.0,
      porcentage: 0.0192,
      year: 2017,
    },
    {
      lowerLimit: 496.08,
      upperLimit: 4210.41,
      fixedFee: 9.52,
      porcentage: 0.064,
      year: 2017,
    },
    {
      lowerLimit: 4210.42,
      upperLimit: 7399.42,
      fixedFee: 247.24,
      porcentage: 0.1088,
      year: 2017,
    },
    {
      lowerLimit: 7399.43,
      upperLimit: 8601.5,
      fixedFee: 594.21,
      porcentage: 0.16,
      year: 2017,
    },
    {
      lowerLimit: 8601.51,
      upperLimit: 10298.35,
      fixedFee: 786.54,
      porcentage: 0.1792,
      year: 2017,
    },
    {
      lowerLimit: 10298.36,
      upperLimit: 20770.29,
      fixedFee: 1090.61,
      porcentage: 0.2136,
      year: 2017,
    },
    {
      lowerLimit: 20770.3,
      upperLimit: 32736.83,
      fixedFee: 3327.42,
      porcentage: 0.2352,
      year: 2017,
    },
    {
      lowerLimit: 32736.84,
      upperLimit: 62500.0,
      fixedFee: 6141.95,
      porcentage: 0.3,
      year: 2017,
    },
    {
      lowerLimit: 62500.01,
      upperLimit: 83333.33,
      fixedFee: 15070.9,
      porcentage: 0.32,
      year: 2017,
    },
    {
      lowerLimit: 83333.34,
      upperLimit: 250000.0,
      fixedFee: 21737.57,
      porcentage: 0.34,
      year: 2017,
    },
    {
      lowerLimit: 250000.01,
      upperLimit: null,
      fixedFee: 78404.23,
      porcentage: 0.35,
      year: 2017,
    },

    {
      lowerLimit: 0.01,
      upperLimit: 578.52,
      fixedFee: 0.0,
      porcentage: 0.0192,
      year: 2018,
    },
    {
      lowerLimit: 578.53,
      upperLimit: 4910.18,
      fixedFee: 11.11,
      porcentage: 0.064,
      year: 2018,
    },
    {
      lowerLimit: 4910.19,
      upperLimit: 8629.2,
      fixedFee: 288.33,
      porcentage: 0.1088,
      year: 2018,
    },
    {
      lowerLimit: 8629.21,
      upperLimit: 10031.07,
      fixedFee: 692.96,
      porcentage: 0.16,
      year: 2018,
    },
    {
      lowerLimit: 10031.08,
      upperLimit: 12009.94,
      fixedFee: 917.26,
      porcentage: 0.1792,
      year: 2018,
    },
    {
      lowerLimit: 12009.95,
      upperLimit: 24222.31,
      fixedFee: 1271.87,
      porcentage: 0.2136,
      year: 2018,
    },
    {
      lowerLimit: 24222.32,
      upperLimit: 38177.69,
      fixedFee: 3880.44,
      porcentage: 0.2352,
      year: 2018,
    },
    {
      lowerLimit: 38177.7,
      upperLimit: 72887.5,
      fixedFee: 7162.74,
      porcentage: 0.3,
      year: 2018,
    },
    {
      lowerLimit: 72887.51,
      upperLimit: 97183.33,
      fixedFee: 17575.69,
      porcentage: 0.32,
      year: 2018,
    },
    {
      lowerLimit: 97183.34,
      upperLimit: 291550.0,
      fixedFee: 25350.35,
      porcentage: 0.34,
      year: 2018,
    },
    {
      lowerLimit: 291550.01,
      upperLimit: null,
      fixedFee: 91435.02,
      porcentage: 0.35,
      year: 2018,
    },

    {
      lowerLimit: 0.01,
      upperLimit: 578.52,
      fixedFee: 0.0,
      porcentage: 0.0192,
      year: 2019,
    },
    {
      lowerLimit: 578.53,
      upperLimit: 4910.18,
      fixedFee: 11.11,
      porcentage: 0.064,
      year: 2019,
    },
    {
      lowerLimit: 4910.19,
      upperLimit: 8629.2,
      fixedFee: 288.33,
      porcentage: 0.1088,
      year: 2019,
    },
    {
      lowerLimit: 8629.21,
      upperLimit: 10031.07,
      fixedFee: 692.96,
      porcentage: 0.16,
      year: 2019,
    },
    {
      lowerLimit: 10031.08,
      upperLimit: 12009.94,
      fixedFee: 917.26,
      porcentage: 0.1792,
      year: 2019,
    },
    {
      lowerLimit: 12009.95,
      upperLimit: 24222.31,
      fixedFee: 1271.87,
      porcentage: 0.2136,
      year: 2019,
    },
    {
      lowerLimit: 24222.32,
      upperLimit: 38177.69,
      fixedFee: 3880.44,
      porcentage: 0.2352,
      year: 2019,
    },
    {
      lowerLimit: 38177.7,
      upperLimit: 72887.5,
      fixedFee: 7162.74,
      porcentage: 0.3,
      year: 2019,
    },
    {
      lowerLimit: 72887.51,
      upperLimit: 97183.33,
      fixedFee: 17575.69,
      porcentage: 0.32,
      year: 2019,
    },
    {
      lowerLimit: 97183.34,
      upperLimit: 291550.0,
      fixedFee: 25350.35,
      porcentage: 0.34,
      year: 2019,
    },
    {
      lowerLimit: 291550.01,
      upperLimit: null,
      fixedFee: 91435.02,
      porcentage: 0.35,
      year: 2019,
    },

    {
      lowerLimit: 0.01,
      upperLimit: 578.52,
      fixedFee: 0.0,
      porcentage: 0.0192,
      year: 2020,
    },
    {
      lowerLimit: 578.53,
      upperLimit: 4910.18,
      fixedFee: 11.11,
      porcentage: 0.064,
      year: 2020,
    },
    {
      lowerLimit: 4910.19,
      upperLimit: 8629.2,
      fixedFee: 288.33,
      porcentage: 0.1088,
      year: 2020,
    },
    {
      lowerLimit: 8629.21,
      upperLimit: 10031.07,
      fixedFee: 692.96,
      porcentage: 0.16,
      year: 2020,
    },
    {
      lowerLimit: 10031.08,
      upperLimit: 12009.94,
      fixedFee: 917.26,
      porcentage: 0.1792,
      year: 2020,
    },
    {
      lowerLimit: 12009.95,
      upperLimit: 24222.31,
      fixedFee: 1271.87,
      porcentage: 0.2136,
      year: 2020,
    },
    {
      lowerLimit: 24222.32,
      upperLimit: 38177.69,
      fixedFee: 3880.44,
      porcentage: 0.2352,
      year: 2020,
    },
    {
      lowerLimit: 38177.7,
      upperLimit: 72887.5,
      fixedFee: 7162.74,
      porcentage: 0.3,
      year: 2020,
    },
    {
      lowerLimit: 72887.51,
      upperLimit: 97183.33,
      fixedFee: 17575.69,
      porcentage: 0.32,
      year: 2020,
    },
    {
      lowerLimit: 97183.34,
      upperLimit: 291550.0,
      fixedFee: 25350.35,
      porcentage: 0.34,
      year: 2020,
    },
    {
      lowerLimit: 291550.01,
      upperLimit: null,
      fixedFee: 91435.02,
      porcentage: 0.35,
      year: 2020,
    },

    {
      lowerLimit: 0.01,
      upperLimit: 644.58,
      fixedFee: 0.0,
      porcentage: 0.0192,
      year: 2021,
    },
    {
      lowerLimit: 644.59,
      upperLimit: 5470.92,
      fixedFee: 12.38,
      porcentage: 0.064,
      year: 2021,
    },
    {
      lowerLimit: 5470.93,
      upperLimit: 9614.66,
      fixedFee: 321.26,
      porcentage: 0.1088,
      year: 2021,
    },
    {
      lowerLimit: 9614.67,
      upperLimit: 11176.62,
      fixedFee: 772.1,
      porcentage: 0.16,
      year: 2021,
    },
    {
      lowerLimit: 11176.63,
      upperLimit: 13381.47,
      fixedFee: 1022.01,
      porcentage: 0.1792,
      year: 2021,
    },
    {
      lowerLimit: 13381.48,
      upperLimit: 26988.5,
      fixedFee: 1417.12,
      porcentage: 0.2136,
      year: 2021,
    },
    {
      lowerLimit: 26988.5,
      upperLimit: 42537.58,
      fixedFee: 4323.58,
      porcentage: 0.2352,
      year: 2021,
    },
    {
      lowerLimit: 42537.59,
      upperLimit: 81211.25,
      fixedFee: 7980.73,
      porcentage: 0.3,
      year: 2021,
    },
    {
      lowerLimit: 81211.26,
      upperLimit: 108281.67,
      fixedFee: 19582.83,
      porcentage: 0.32,
      year: 2021,
    },
    {
      lowerLimit: 108281.68,
      upperLimit: 324845.01,
      fixedFee: 28245.36,
      porcentage: 0.34,
      year: 2021,
    },
    {
      lowerLimit: 324845.02,
      upperLimit: null,
      fixedFee: 101876.9,
      porcentage: 0.35,
      year: 2021,
    },
    {
      lowerLimit: 0.01,
      upperLimit: 644.58,
      fixedFee: 0.0,
      porcentage: 0.0192,
      year: 2022,
    },
    {
      lowerLimit: 644.59,
      upperLimit: 5470.92,
      fixedFee: 12.38,
      porcentage: 0.064,
      year: 2022,
    },
    {
      lowerLimit: 5470.93,
      upperLimit: 9614.66,
      fixedFee: 321.26,
      porcentage: 0.1088,
      year: 2022,
    },
    {
      lowerLimit: 9614.67,
      upperLimit: 11176.62,
      fixedFee: 772.1,
      porcentage: 0.16,
      year: 2022,
    },
    {
      lowerLimit: 11176.63,
      upperLimit: 13381.47,
      fixedFee: 1022.01,
      porcentage: 0.1792,
      year: 2022,
    },
    {
      lowerLimit: 13381.48,
      upperLimit: 26988.5,
      fixedFee: 1417.12,
      porcentage: 0.2136,
      year: 2022,
    },
    {
      lowerLimit: 26988.5,
      upperLimit: 42537.58,
      fixedFee: 4323.58,
      porcentage: 0.2352,
      year: 2022,
    },
    {
      lowerLimit: 42537.59,
      upperLimit: 81211.25,
      fixedFee: 7980.73,
      porcentage: 0.3,
      year: 2022,
    },
    {
      lowerLimit: 81211.26,
      upperLimit: 108281.67,
      fixedFee: 19582.83,
      porcentage: 0.32,
      year: 2022,
    },
    {
      lowerLimit: 108281.68,
      upperLimit: 324845.01,
      fixedFee: 28245.36,
      porcentage: 0.34,
      year: 2022,
    },
    {
      lowerLimit: 324845.02,
      upperLimit: null,
      fixedFee: 101876.9,
      porcentage: 0.35,
      year: 2022,
    },
    {
      lowerLimit: 0.01,
      upperLimit: 746.04,
      fixedFee: 0.0,
      porcentage: 0.0192,
      year: 2023,
    },
    {
      lowerLimit: 746.05,
      upperLimit: 6332.05,
      fixedFee: 14.32,
      porcentage: 0.064,
      year: 2023,
    },
    {
      lowerLimit: 6332.06,
      upperLimit: 11128.01,
      fixedFee: 371.83,
      porcentage: 0.1088,
      year: 2023,
    },
    {
      lowerLimit: 11128.02,
      upperLimit: 12935.82,
      fixedFee: 893.63,
      porcentage: 0.16,
      year: 2023,
    },
    {
      lowerLimit: 12935.83,
      upperLimit: 15487.71,
      fixedFee: 1182.88,
      porcentage: 0.1792,
      year: 2023,
    },
    {
      lowerLimit: 15487.72,
      upperLimit: 31236.49,
      fixedFee: 1640.18,
      porcentage: 0.2136,
      year: 2023,
    },
    {
      lowerLimit: 31236.5,
      upperLimit: 49233.0,
      fixedFee: 5004.12,
      porcentage: 0.2352,
      year: 2023,
    },
    {
      lowerLimit: 49233.01,
      upperLimit: 93993.9,
      fixedFee: 9236.89,
      porcentage: 0.3,
      year: 2023,
    },
    {
      lowerLimit: 93993.91,
      upperLimit: 125325.2,
      fixedFee: 22665.17,
      porcentage: 0.32,
      year: 2023,
    },
    {
      lowerLimit: 125325.21,
      upperLimit: 375975.61,
      fixedFee: 32691.18,
      porcentage: 0.34,
      year: 2023,
    },
    {
      lowerLimit: 375975.62,
      upperLimit: null,
      fixedFee: 117912.32,
      porcentage: 0.35,
      year: 2023,
    },
    // Aqui comienza el 2024
    {
      lowerLimit: 0.01,
      upperLimit: 746.04,
      fixedFee: 0.0,
      porcentage: 0.0192,
      year: 2024,
    },
    {
      lowerLimit: 746.05,
      upperLimit: 6332.05,
      fixedFee: 14.32,
      porcentage: 0.064,
      year: 2024,
    },
    {
      lowerLimit: 6332.06,
      upperLimit: 11128.01,
      fixedFee: 371.83,
      porcentage: 0.1088,
      year: 2024,
    },
    {
      lowerLimit: 11128.02,
      upperLimit: 12935.82,
      fixedFee: 893.63,
      porcentage: 0.16,
      year: 2024,
    },
    {
      lowerLimit: 12935.83,
      upperLimit: 15487.71,
      fixedFee: 1182.88,
      porcentage: 0.1792,
      year: 2024,
    },
    {
      lowerLimit: 15487.72,
      upperLimit: 31236.49,
      fixedFee: 1640.18,
      porcentage: 0.2136,
      year: 2024,
    },
    {
      lowerLimit: 31236.5,
      upperLimit: 49233.0,
      fixedFee: 5004.12,
      porcentage: 0.2352,
      year: 2024,
    },
    {
      lowerLimit: 49233.01,
      upperLimit: 93993.9,
      fixedFee: 9236.89,
      porcentage: 0.3,
      year: 2024,
    },
    {
      lowerLimit: 93993.91,
      upperLimit: 125325.2,
      fixedFee: 22665.17,
      porcentage: 0.32,
      year: 2024,
    },
    {
      lowerLimit: 125325.21,
      upperLimit: 375975.61,
      fixedFee: 32691.18,
      porcentage: 0.34,
      year: 2024,
    },
    {
      lowerLimit: 375975.62,
      upperLimit: null,
      fixedFee: 117912.32,
      porcentage: 0.35,
      year: 2024,
    },
    // Aqui comienza el 2025
    {
      lowerLimit: 0.01,
      upperLimit: 746.04,
      fixedFee: 0.0,
      porcentage: 0.0192,
      year: 2025,
    },
    {
      lowerLimit: 746.05,
      upperLimit: 6332.05,
      fixedFee: 14.32,
      porcentage: 0.064,
      year: 2025,
    },
    {
      lowerLimit: 6332.06,
      upperLimit: 11128.01,
      fixedFee: 371.83,
      porcentage: 0.1088,
      year: 2025,
    },
    {
      lowerLimit: 11128.02,
      upperLimit: 12935.82,
      fixedFee: 893.63,
      porcentage: 0.16,
      year: 2025,
    },
    {
      lowerLimit: 12935.83,
      upperLimit: 15487.71,
      fixedFee: 1182.88,
      porcentage: 0.1792,
      year: 2025,
    },
    {
      lowerLimit: 15487.72,
      upperLimit: 31236.49,
      fixedFee: 1640.18,
      porcentage: 0.2136,
      year: 2025,
    },
    {
      lowerLimit: 31236.5,
      upperLimit: 49233.0,
      fixedFee: 5004.12,
      porcentage: 0.2352,
      year: 2025,
    },
    {
      lowerLimit: 49233.01,
      upperLimit: 93993.9,
      fixedFee: 9236.89,
      porcentage: 0.3,
      year: 2025,
    },
    {
      lowerLimit: 93993.91,
      upperLimit: 125325.2,
      fixedFee: 22665.17,
      porcentage: 0.32,
      year: 2025,
    },
    {
      lowerLimit: 125325.21,
      upperLimit: 375975.61,
      fixedFee: 32691.18,
      porcentage: 0.34,
      year: 2025,
    },
    {
      lowerLimit: 375975.62,
      upperLimit: null,
      fixedFee: 117912.32,
      porcentage: 0.35,
      year: 2025,
    },
    // Aqui comienza el 2026 606 Arrendamiento
    {
      lowerLimit: 0.01,
      upperLimit: 844.59,
      fixedFee: 0.0,
      porcentage: 0.0192,
      year: 2026,
    },
    {
      lowerLimit: 844.6,
      upperLimit: 7168.51,
      fixedFee: 16.22,
      porcentage: 0.064,
      year: 2026,
    },
    {
      lowerLimit: 7168.52,
      upperLimit: 12598.02,
      fixedFee: 420.95,
      porcentage: 0.1088,
      year: 2026,
    },
    {
      lowerLimit: 12598.03,
      upperLimit: 14644.64,
      fixedFee: 1011.68,
      porcentage: 0.16,
      year: 2026,
    },
    {
      lowerLimit: 14644.65,
      upperLimit: 17533.64,
      fixedFee: 1339.14,
      porcentage: 0.1792,
      year: 2026,
    },
    {
      lowerLimit: 17533.65,
      upperLimit: 35362.83,
      fixedFee: 1856.84,
      porcentage: 0.2136,
      year: 2026,
    },
    {
      lowerLimit: 35362.84,
      upperLimit: 55736.68,
      fixedFee: 5665.16,
      porcentage: 0.2352,
      year: 2026,
    },
    {
      lowerLimit: 55736.69,
      upperLimit: 106410.5,
      fixedFee: 10457.09,
      porcentage: 0.3,
      year: 2026,
    },
    {
      lowerLimit: 106410.51,
      upperLimit: 141880.66,
      fixedFee: 25659.23,
      porcentage: 0.32,
      year: 2026,
    },
    {
      lowerLimit: 141880.67,
      upperLimit: 425641.99,
      fixedFee: 37009.69,
      porcentage: 0.34,
      year: 2026,
    },
    {
      lowerLimit: 425642.0,
      upperLimit: null,
      fixedFee: 133488.54,
      porcentage: 0.35,
      year: 2026,
    },
  ],
};

export const isrLeaseReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
